import { render, staticRenderFns } from "./ChangeEmailActivationEmailFailed.vue?vue&type=template&id=37eca144&scoped=true&"
import script from "./ChangeEmailActivationEmailFailed.vue?vue&type=script&lang=ts&"
export * from "./ChangeEmailActivationEmailFailed.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeEmailActivationEmailFailed.vue?vue&type=style&index=0&id=37eca144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eca144",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
